import Nav from "./Navigation.js";

const paintingsData = [
  { id: 1, name: "Batuhan", imagePath: "Batuhan.PNG", aka: "Chair" },
  { id: 2, name: "Ben", imagePath: "Ben.PNG", aka: "Brown Suit" },
  { id: 3, name: "Fabio", imagePath: "Fabio.PNG", aka: " 'Hello there' " },
  { id: 4, name: "Faiter", imagePath: "Faiter.PNG", aka: "Banister" },
  {
    id: 5,
    name: "Greedy",
    imagePath: "Greedy.PNG",
    aka: "Soul 'stares into your soul'",
  },
  { id: 6, name: "Gryphon", imagePath: "Gryphon.PNG", aka: "Smokes" },
  { id: 7, name: "Hayley", imagePath: "Hayley.PNG", aka: "Pink Dress" },
  { id: 8, name: "Igor", imagePath: "Igor.PNG", aka: "Cigar N Scotch" },
  { id: 9, name: "Leonid", imagePath: "Leonid.PNG", aka: "White Suit" },
  { id: 10, name: "Michal", imagePath: "Michal.PNG", aka: "Hefner" },
  { id: 11, name: "Muhammed", imagePath: "Muhammed.PNG", aka: "Gomez Adams" },
  { id: 12, name: "Nanque", imagePath: "Nanque.PNG", aka: "Blue Dress" },
  { id: 13, name: "Ozan", imagePath: "Ozan.PNG", aka: "Red Suit" },
  { id: 14, name: "Shadow", imagePath: "Shadow.PNG", aka: "Side Beard" },
  { id: 15, name: "Tanner", imagePath: "Tanner.PNG", aka: "Ruffles" },
  { id: 16, name: "Zak", imagePath: "Zak.PNG", aka: "Table" },
];

export default function PaintingSolver() {

  const renderItem = (painting) => (
    <div key={painting.name}>
      <img
        className="object-scale-down h-48 cursor-pointer"
        src={require(`../images/${painting.imagePath}`)}
        alt={painting.name}
      />
      <div>{painting.name}</div>
      <div>aka {painting.aka}</div>
    </div>
  );

  return (
    <div className="text-white">
      <Nav />
        <div className="items-center grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
          {paintingsData.map((painting) => (
            <div key={painting.id}>{renderItem(painting)}</div>
          ))}
        </div>
    </div>
  );
}
